import useSWR from 'swr';
import { Language, ViewResponse } from '@yleisradio/areena-types';
import { fetchViewByPath } from '../../service/areena-api/fetchers';
import { isServiceId } from '../utils/item';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';

type RequestKey = [
  'player.json',
  languageCode: Language,
  itemId: string,
  programId?: string,
  publicationId?: string,
];

type Props = {
  itemId: string | undefined | null;
  programId?: string;
  publicationId?: string;
};

async function fetcher([
  ,
  languageCode,
  itemId,
  programId,
  publicationId,
]: RequestKey): Promise<ViewResponse> {
  if (!itemId) {
    throw new Error('Item ID is required to fetch player view');
  }
  const isSimulcastLive = isServiceId(itemId);
  if (isSimulcastLive) {
    if (programId && publicationId) {
      return fetchViewByPath(
        `services/${itemId}/player/${programId}/${publicationId}`,
        languageCode
      );
    }
    return fetchViewByPath(`services/${itemId}/player`, languageCode);
  }
  return fetchViewByPath(`items/${itemId}/player`, languageCode);
}

export const useFetchPlayerView = ({
  itemId,
  programId,
  publicationId,
}: Props) => {
  const { languageCode } = useAppFeaturesContext();
  const { data, isLoading } = useSWR(
    itemId
      ? ([
          'player.json',
          languageCode,
          itemId,
          programId,
          publicationId,
        ] satisfies RequestKey)
      : null,
    fetcher
  );
  return { data, isLoading };
};
